import http from "@/api/http";
import { AxiosResponse, AxiosError } from "axios";
import { EnterpriseAdapterApi } from "@vacancorp/enterprise.adapter.api.vacanservice.com";

export const getWebsiteListByCompanyId = (
  companyId: string,
  filterString: string,
  page?: number
): Promise<EnterpriseAdapterApi.ResponseGetWebsiteList> => {
  const reqUrl =
    page === undefined
      ? `/v1/companies/${companyId}/websites?filter=${filterString}`
      : `/v1/companies/${companyId}/websites?filter=${filterString}&page=${page}`;
  return http
    .get(reqUrl)
    .then((response: AxiosResponse) =>
      response.status === 204 ? undefined : response.data
    )
    .catch((error: AxiosError) => {
      Promise.reject(
        error.response ? error.response.data.errors : "Unknown Error"
      );
    });
};

export const getWebsiteByCompanyId = (
  companyId: string,
  websiteId: string
): Promise<EnterpriseAdapterApi.ResponseGetWebsite> => {
  return http
    .get(`/v1/companies/${companyId}/websites/${websiteId}`)
    .then((response: AxiosResponse) =>
      response.status === 204 ? undefined : response.data
    )
    .catch((error: AxiosError) => {
      Promise.reject(
        error.response ? error.response.data.errors : "Unknown Error"
      );
    });
};

export const postWebsiteInCompany = (
  companyId: string,
  website: EnterpriseAdapterApi.RequestPostWebsite
): Promise<EnterpriseAdapterApi.ResponseGetWebsiteList> => {
  return http
    .post(`/v1/companies/${companyId}/websites`, {
      displayName: website.displayName,
      passcode: website.passcode,
      useTenantIdPass: website.useTenantIdPass,
      memo: website.memo,
    })
    .then((response: AxiosResponse) =>
      response.status === 204 ? undefined : response.data
    )
    .catch((error: AxiosError) => {
      Promise.reject(
        error.response ? error.response.data.errors : "Unknown Error"
      );
    });
};

export const putWebsiteInCompany = (
  companyId: string,
  websiteId: string,
  website: EnterpriseAdapterApi.RequestPutWebsite
): Promise<EnterpriseAdapterApi.RequestPutWebsite> => {
  return http
    .put(`/v1/companies/${companyId}/websites/${websiteId}`, {
      displayName: website.displayName,
      passcode: website.passcode,
      useTenantIdPass: website.useTenantIdPass,
      memo: website.memo,
    })
    .then((response: AxiosResponse) =>
      response.status === 204 ? undefined : response.data
    )
    .catch((error: AxiosError) => {
      Promise.reject(
        error.response ? error.response.data.errors : "Unknown Error"
      );
    });
};

export const deleteWebsiteInCompany = (
  companyId: string,
  websiteId: string
): Promise<void> => {
  return http
    .delete(`/v1/companies/${companyId}/websites/${websiteId}`)
    .then(() => {
      return;
    })
    .catch((error: AxiosError) =>
      Promise.reject(
        error.response ? error.response.data.errors : "TODO: Unknown Error"
      )
    );
};
